export const fitting = `
[Myrmidon, Myrmidon - FOB]
Thermal Armor Hardener II
Multispectrum Coating II
Damage Control II
EM Armor Hardener II
Drone Damage Amplifier II
Drone Damage Amplifier II

Large Compact Pb-Acid Cap Battery
Cap Recharger II
Cap Recharger II
Cap Recharger II
10MN Afterburner II

Medium Remote Armor Repairer II
Medium Remote Armor Repairer II
Medium Remote Armor Repairer II
Large Remote Capacitor Transmitter II
Medium Remote Capacitor Transmitter II

Medium Remote Repair Augmentor II
Medium Thermal Armor Reinforcer II
Medium EM Armor Reinforcer II

Hobgoblin II x5
Hammerhead II x5
Ogre II x5
`
